globalThis.backoffice = globalThis.backoffice || {};

backoffice.CallCenter = (function()
{
  var defaults = {
    loader: null,
    selectors: {
      successOverlay: '.overlay-success',
      errorOverlay: '.overlay-error'
    }
  }

  function CallCenter($html, options) {
    this.$html = $html;
    this.config = $.extend({}, defaults, options);
    if(this.$html) {
      this.voipProvider = this.$html.data('voip-provider');
      this.$modalDialog = this.$html.find('.modal-dialog');
    }
    this.init();
  }

  CallCenter.prototype = {
    init: function() {
      if(this.$html) {
        this.initClickToCall();
        this.initManualCall();
        this.initQualificationCallForms();
      }
    },
    initClickToCall : function() {
      var self = this;

      self.$html.on('change', 'select[name=called_number]', function() {
        $(this).closest('form').find('input[name=contact_id]').val($(this).find('option:selected').data('id'));
      });

      self.$html.on('click', 'button.launch-phone-call', function(e) {
        e.preventDefault();

        var $form = $(this).closest('form'),
            calledNumber = $form.find('select[name=called_number]').val(),
            callingNumber = $form.find('select[name=caller_number]').val();

        $form.find('input[name=contact_id]').val($form.find('select[name=called_number] option:selected').data('id'));

        if(calledNumber) {
          (self.$modalDialog.length ? self.$modalDialog : self.$html).block({
            message: '<i class="icon-spinner3 spinner"></i>',
            overlayCSS: {
              backgroundColor: '#1B2024',
              opacity: 0.5,
              cursor: 'wait'
            },
            css: {
              border: 0,
              padding: 0,
              backgroundColor: 'none',
              color: '#fff'
            }
          });
          self.startCall(calledNumber, callingNumber);
        }
      });
    },
    startCall: function(calledNumber, callingNumber) {
      var self = this,
          service = null;

      switch(this.voipProvider) {
        case 'graam':
          service = new backoffice.integrations.voip.Graam();
          break;
        case 'aircall':
          service = new backoffice.integrations.voip.Aircall();
          break;
      }

      if(service) {
        service.startCall(calledNumber, callingNumber, function() {
          (self.$modalDialog.length ? self.$modalDialog : self.$html).unblock();
          self.displaySuccessOverlay();

          setTimeout(function() {
            self.$html.modal('hide');
          }, 5000);
        });
      }
    },
    initManualCall: function() {
      var self = this;

      autosize(this.$html.find('.autosize'));
      ContainersToggler.init(this.$html);

      this.$html.find('.datepicker').each(function() {
        var $this = $(this);

        $this.daterangepicker(
          {
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            showDropdowns: true,
            autoApply: false,
            autoUpdateInput: false,
            drops: "up",
            locale: {
              format: 'DD-MM-YYYY HH:mm'
            }
          },
          function(start, end, label) {
            $this.val(start.format(this.locale.format)).change();
          }
        );
      }).on('show.daterangepicker', function(e, picker) {
        var $this = $(this),
            daterangepicker = $this.data('daterangepicker');

        window.currentDatepickerElement = $this;
        var $singleCalendar = $(daterangepicker.container).find('.calendar.left.single');

        if(!daterangepicker.autoApply && $singleCalendar.length && $singleCalendar.find('.apply').length == 0) {
          $singleCalendar.append('<button class="apply btn btn-sm btn-success full-width" type="button">Appliquer</button>');
        }
      });

      this.$html.on('click', '.save-call', function(e) {
        e.preventDefault();

        var $this = $(this),
            $form = $this.closest('form');

        $form.find('.validation-error').remove();

        $.post($form.attr('action') + '.json', $form.serialize(), function(data) {
          if(data.response) {
            self.displaySuccessOverlay("Appel enregisté");
          } else if(data.errors) {
            $.each(data.errors, function(k, v) {
              var $input = $form.find('input[name*=' + k + ']');

              if($input.length) {
                $('<span/>', {
                  class: 'text-danger text-semibold validation-error',
                  style: 'font-size: 11px;padding-left: 4px;',
                  text: v
                }).insertAfter($input.closest('.form-group').find('label'));
              }
            });
          }
        });

        return false;
      });

      this.$html.on('click', '.call-quality-score', function() {
        $(this).prevAll().addBack().each(function() {
          $(this).addClass('active');
        });
        $(this).nextAll().each(function() {
          $(this).removeClass('active');
        });
      });
    },
    initQualificationCallForms: function() {
      const phoneCallQualification = new backoffice.PhoneCallQualification($('#phone-call-qualification-form'));
      const videoCallQualification = new backoffice.PhoneCallQualification($('#video-call-qualification-form'));
    },
    displaySuccessOverlay: function(message) {
      var $message = this.$html.find('.success-message');

      if(message) {
        $message.text(message);
      }

      this.$html.find(this.config.selectors.successOverlay).fadeIn('fast');
    },
    displayErrorOverlay: function(message) {
      this.$html.find(this.config.selectors.errorOverlay)
                  .find('.error-message').text(message).end()
                  .fadeIn('fast');
    }
  }

  return CallCenter;
})();
